"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = exports.darkColors = void 0;
var darkColors = {
  appBackground: '#000',
  appBackgroundRgb: [0, 0, 0],
  textDefault: '#ffffff',
  textSecondary: '#757575',
  textTertiary: '#ffffff',
  textRed: '#E60046',
  textTitle: '#ffffff',
  primary: '#73C70C',
  primaryContrastText: '#fff',
  secondary: '#000',
  secondaryContrastText: '#fff',
  tertiary: '#192C03',
  tertiaryContrastText: '#fff',
  disabled: '#E1E1E1',
  disabledText: '#757575',
  blocBg: '#111111',
  blocHeaderBg: '#111111',
  blocTitle: '#73C70C'
};
exports.darkColors = darkColors;
var colors = {
  appBackground: '#000',
  appBackgroundRgb: [0, 0, 0],
  textDefault: '#122D00',
  textSecondary: '#757575',
  textTertiary: '#192C03',
  textRed: '#E60046',
  textTitle: '#192C03',
  primary: '#73C70C',
  primaryContrastText: '#fff',
  secondary: '#223B04',
  secondaryContrastText: '#fff',
  tertiary: '#192C03',
  tertiaryContrastText: '#fff',
  disabled: '#E1E1E1',
  disabledText: '#757575',
  blocBg: '#fff',
  blocHeaderBg: '#73C70C',
  blocTitle: '#fff'
};
exports.colors = colors;